import { windowWidth } from 'lib/helper/windowWidth';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import styles from '/styles/scss/navigation/finalThoughts.module.scss';

export default function FinalThoughts({ content }: { content: string }): JSX.Element {
    const [isShown, setIsShown] = useState(true);
    const [finalThoughtsExists, setFinalThoughtExists] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const finalThoughtsId = 'final-thoughts';
    const router = useRouter();

    const width = windowWidth();
    useEffect(() => {
        //initially check when page is loaded if finalthoughts exist
        const finalThoughts = window.document.getElementById(finalThoughtsId);
        if (finalThoughts) {
            setFinalThoughtExists(true);
        } else {
            setFinalThoughtExists(false);
        }
    }, []);

    useEffect(() => {
        //check on language change if finalthoughts exists
        const handleLocaleChange = () => {
            const finalThoughts = window.document.getElementById(finalThoughtsId);
            if (finalThoughts) {
                setFinalThoughtExists(true);
            } else {
                setFinalThoughtExists(false);
            }
        };

        router.events.on('routeChangeComplete', handleLocaleChange);

        return () => {
            router.events.off('routeChangeComplete', handleLocaleChange);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.scrollY;
            const hideElement = document.getElementById(finalThoughtsId);

            if (
                (currentScrollPos < 1500 || currentScrollPos < prevScrollPos) &&
                (!hideElement || currentScrollPos < hideElement.offsetTop)
            ) {
                setIsShown(true);
            } else {
                setIsShown(false);
            }

            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [prevScrollPos]);

    const ScrollToFinalThoughts = () => {
        const finalThoughtsId = document.getElementById('final-thoughts');
        let offSet;

        if (width < 500) {
            offSet = 1200;
        } else if (width > 1200) {
            offSet = 1050;
        } else {
            offSet = 1000;
        }

        if (finalThoughtsId) {
            const scrollToPosition = finalThoughtsId.offsetTop + offSet;

            window.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth'
            });
        }
    };
    return (
        <>
            {finalThoughtsExists ? (
                <div
                    className={styles.backToTop + ' pointer ' + (isShown ? styles.fadeIn : '')}
                    onClick={() => ScrollToFinalThoughts()}
                    onKeyDown={() => ScrollToFinalThoughts()}
                    role="button"
                    aria-hidden="true">
                    {content}
                    <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_33_3488)">
                            <path
                                d="M13.375 8.51042C13.375 8.69792 13.3125 8.85417 13.1875 8.97917L9.41667 12.75L8.46875 13.6979C8.34375 13.8229 8.1875 13.8854 8 13.8854C7.8125 13.8854 7.65625 13.8229 7.53125 13.6979L6.58333 12.75L2.8125 8.97917C2.6875 8.85417 2.625 8.69792 2.625 8.51042C2.625 8.32292 2.6875 8.16667 2.8125 8.04167L3.76042 7.09375C3.88542 6.96875 4.04167 6.90625 4.22917 6.90625C4.41667 6.90625 4.57292 6.96875 4.69792 7.09375L6.66667 9.0625V3.83333C6.66667 3.65278 6.73264 3.49653 6.86458 3.36458C6.99653 3.23264 7.15278 3.16667 7.33333 3.16667H8.66667C8.84722 3.16667 9.00347 3.23264 9.13542 3.36458C9.26736 3.49653 9.33333 3.65278 9.33333 3.83333V9.0625L11.3021 7.09375C11.434 6.96181 11.5903 6.89583 11.7708 6.89583C11.9514 6.89583 12.1076 6.96181 12.2396 7.09375L13.1875 8.04167C13.3125 8.16667 13.375 8.32292 13.375 8.51042ZM16 8.5C16 7.04861 15.6424 5.71007 14.9271 4.48438C14.2118 3.25868 13.2413 2.28819 12.0156 1.57292C10.7899 0.857638 9.45139 0.5 8 0.5C6.54861 0.5 5.21007 0.857638 3.98438 1.57292C2.75868 2.28819 1.78819 3.25868 1.07292 4.48438C0.357639 5.71007 0 7.04861 0 8.5C0 9.95139 0.357639 11.2899 1.07292 12.5156C1.78819 13.7413 2.75868 14.7118 3.98438 15.4271C5.21007 16.1424 6.54861 16.5 8 16.5C9.45139 16.5 10.7899 16.1424 12.0156 15.4271C13.2413 14.7118 14.2118 13.7413 14.9271 12.5156C15.6424 11.2899 16 9.95139 16 8.5Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_33_3488">
                                <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="matrix(1 0 0 -1 0 16.5)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            ) : null}
        </>
    );
}
